/*
 * "Sucursal más cercana" widget for the store locator page.
 * Reuses the store data and map API already exposed globally by the
 * existing store-locator Vue app (window.$StoreLocator) instead of
 * duplicating the store list. Purely additive — does not modify the
 * compiled store-locator bundle. ADDED BY CLAUDE.
 */
(function () {
  var CFG = window.choStoreFinderSettings || {};
  var RESULTS_LIMIT = CFG.resultsCount || 5;

  function toRad(value) {
    return (value * Math.PI) / 180;
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function getStores() {
    return (window.$StoreLocator && window.$StoreLocator.state && window.$StoreLocator.state.stores) || [];
  }

  function waitFor(check, cb, timeoutMs) {
    var waited = 0;
    var interval = 200;
    var timer = setInterval(function () {
      waited += interval;
      if (check()) {
        clearInterval(timer);
        cb();
      } else if (waited >= (timeoutMs || 15000)) {
        clearInterval(timer);
      }
    }, interval);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderResults(lat, lng) {
    var resultsEl = document.getElementById('choNearestResults');
    if (!resultsEl) return;

    var stores = getStores();
    if (!stores.length) return;

    var withDistance = stores
      .filter(function (s) {
        return s.lat && s.lng && !isNaN(Number(s.lat)) && !isNaN(Number(s.lng));
      })
      .map(function (s) {
        return { store: s, distance: haversineKm(lat, lng, Number(s.lat), Number(s.lng)) };
      })
      .sort(function (a, b) {
        return a.distance - b.distance;
      })
      .slice(0, RESULTS_LIMIT);

    if (!withDistance.length) {
      resultsEl.innerHTML = '<p class="cho-nearest-finder__empty">No encontramos sucursales cercanas.</p>';
      resultsEl.hidden = false;
      return;
    }

    resultsEl.innerHTML = withDistance
      .map(function (item) {
        var s = item.store;
        var km = item.distance < 1 ? Math.round(item.distance * 1000) + ' m' : item.distance.toFixed(1) + ' km';
        return (
          '<button type="button" class="cho-nearest-finder__item" data-store-key="' +
          escapeHtml(s.key) +
          '">' +
          '<span class="cho-nearest-finder__item-name">' +
          escapeHtml(s.name) +
          '</span>' +
          '<span class="cho-nearest-finder__item-distance">' +
          km +
          '</span>' +
          '<span class="cho-nearest-finder__item-address">' +
          escapeHtml(s.address1) +
          '</span>' +
          '</button>'
        );
      })
      .join('');
    resultsEl.hidden = false;

    Array.prototype.slice.call(resultsEl.querySelectorAll('[data-store-key]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectStore(btn.getAttribute('data-store-key'), stores);
      });
    });
  }

  function selectStore(key, stores) {
    var found = stores.find(function (s) {
      return s.key === key;
    });
    if (!found || !window.$StoreLocator) return;

    // Selecting a nearby result is a different way of finding a store than
    // the province/locality dropdowns, so clear those out — otherwise their
    // (now unrelated) filter stays active and the full list would still be
    // considered "filtered" behind the scenes.
    window.$StoreLocator.state.filter.province = '';
    window.$StoreLocator.state.filter.location = '';

    var apply = function () {
      window.$StoreLocator.state.filter.selectedStore = key;
      window.$StoreLocator.methods.updateMapPosition({
        lat: Number(found.lat),
        lng: Number(found.lng),
        zoom: 15,
      });
    };

    if (window.$StoreLocator.state.filter.selectedStore) {
      // A store's detail view is already open. It only reads the selected
      // store once when it mounts, so briefly clearing the selection forces
      // it to remount and pick up the newly selected store instead of
      // requiring the user to hit "back" first.
      window.$StoreLocator.state.filter.selectedStore = '';
      setTimeout(apply, 0);
    } else {
      apply();
    }

    var mapEl = document.getElementById('store-locator-map');
    if (mapEl) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initInputClearing() {
    var input = document.getElementById('choNearestInput');
    if (!input || input.dataset.choClearInit) return;
    input.dataset.choClearInit = '1';

    input.addEventListener('input', function () {
      // Any manual edit (including clearing the field) invalidates the
      // previous results, since they no longer match what's typed.
      var resultsEl = document.getElementById('choNearestResults');
      if (!resultsEl) return;
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
    });
  }

  function initAutocomplete() {
    var input = document.getElementById('choNearestInput');
    if (!input || !window.google || !window.google.maps || !window.google.maps.places) return;

    var autocomplete = new google.maps.places.Autocomplete(input, {
      fields: ['geometry', 'formatted_address'],
      componentRestrictions: { country: 'ar' },
    });

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.geometry || !place.geometry.location) return;
      renderResults(place.geometry.location.lat(), place.geometry.location.lng());
    });
  }

  function initLocateButton() {
    var btn = document.getElementById('choNearestLocateBtn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        alert('Tu navegador no admite geolocalización. Escribí tu dirección en el buscador.');
        return;
      }
      btn.disabled = true;
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          btn.disabled = false;
          renderResults(pos.coords.latitude, pos.coords.longitude);
        },
        function () {
          btn.disabled = false;
          alert('No pudimos acceder a tu ubicación. Podés escribir tu dirección en el buscador.');
        }
      );
    });
  }

  function relocateWidget(retriesLeft) {
    var contentApp = document.querySelector('#contentApp');
    var widget = document.getElementById('choNearestFinder');
    if (!widget) return;
    if (contentApp) {
      if (widget.parentElement !== contentApp || contentApp.firstElementChild !== widget) {
        contentApp.insertBefore(widget, contentApp.firstChild);
      }
      // Only reveal it now that it's in its final spot — avoids the
      // flash-then-jump from its original position above the title.
      widget.classList.add('cho-nearest-finder--ready');
      return;
    }
    if (retriesLeft === undefined) retriesLeft = 50;
    if (retriesLeft <= 0) {
      // Couldn't find #contentApp after ~10s — reveal it anyway wherever it
      // is rather than leaving it invisible forever.
      widget.classList.add('cho-nearest-finder--ready');
      return;
    }
    setTimeout(function () {
      relocateWidget(retriesLeft - 1);
    }, 200);
  }

  function watchFilters(retriesLeft) {
    var container = document.getElementById('appContainer');
    if (!container || !window.$StoreLocator) {
      if (retriesLeft === undefined) retriesLeft = 50;
      if (retriesLeft <= 0) return;
      setTimeout(function () {
        watchFilters(retriesLeft - 1);
      }, 200);
      return;
    }

    function update() {
      var f = window.$StoreLocator.state.filter;
      var filtersComplete = !!(f.province && f.location);
      container.classList.toggle('cho-filters-pending', !filtersComplete);
      // While a store's detail view is open, the province/locality dropdowns
      // just take up space above it (pushing it below the fold), so hide
      // them until the user goes "back" to the list.
      container.classList.toggle('cho-store-selected', !!f.selectedStore);
    }

    update();
    setInterval(update, 300);
  }

  function init() {
    initLocateButton();
    initInputClearing();
    relocateWidget();
    watchFilters();
    waitFor(
      function () {
        return getStores().length > 0 && window.google && window.google.maps && window.google.maps.places;
      },
      initAutocomplete
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
